import React, { useEffect, useState } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
// import { Col, FormGroup, Input, Label, Row } from 'reactstrap';
import { ToggleSwitch } from '../ToggleSwitch';
import { TextEditor } from '../TextEditor';
import { ModelTypes, Visibility } from '../../models/APIModels';
import {
  Card,
  Container,
  FormControlLabel,
  Grid,
  InputAdornment,
  MenuItem,
  Switch,
  TextField,
  Tooltip,
  Typography,
} from '@mui/material';
import { ApiHelper } from '../../common/ApiHelper';
import { CircularProgress } from '@mui/material';
import AutoCompleteSelect from '../AutoComplete/AutoCompleteSelect';
import InfoRoundedIcon from '@mui/icons-material/InfoRounded';
import { MODEL_CATEGORIES, MODEL_LIST, MODEL_TAGS } from '../../constants';
import SupportingLinks from './SupportingLinks';
import Matrics from './Matrics';
import modelUtils from '../../Utils/modelUtils';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import useAppUtils from '../../Utils/useAppUtils';
import clientUtils from '../../Utils/clientUtils';
// import "bootstrap/dist/scss/bootstrap.min.scss";

const ModelInfo = ({ formValues, orginalModel }) => {
  // ▶️ Variables .....
  const { control } = formValues;

  const [active, setActive] = useState(formValues.getValues('active'));
  const [isPublic, setIsPublic] = useState(formValues.getValues('isPublic'));
  const [visibility, setVisibilty] = useState(formValues.getValues('visibility'));
  const [modelLongDescription, setmodelLongDescription] = useState(formValues.getValues('modelLongDescriptionValue') ?? '');
  const [modelType, setModelType] = useState(formValues.getValues('modelType'));
  const [imageData, setImageData] = useState('');
  const [imageUrl, setImageUrl] = useState(formValues.getValues('externalRedirectUrl') ?? '');
  const [isLoading, setIsLoading] = useState(false);
  const [modelCategory, setModelCategory] = useState(formValues.getValues('modelCategory') ?? '');
  const [selectedModelType, setSelectedModelType] = useState('');

  const [modelAliasInputLabelProps, setModelAliasInputLabelProps] = useState(false);
  const [ModelUrl, setModelUrl] = useState('');
  const {
    register,
    getValues,
    setValue,
    formState: { errors },
  } = useFormContext();
  const { alert } = useAppUtils();

  // ▶️ Functions / Methods .....

  const getImageData = async (url: string) => {
    try {
      setIsLoading(true);
      const response = await ApiHelper.GetScreenshotByUrl(formValues.getValues('externalRedirectUrl'));
      if (response.status === 200 && response.data) {
        setIsLoading(false);
        setImageData(response.data);
      } else {
        setIsLoading(false);
      }
    } catch (e) {
      setIsLoading(false);
      // console.log('ERRR');
    }
  };

  const onEditorChange = (value) => {
    // console.log('value', value);
    setmodelLongDescription(value);
    formValues.setValue('modelLongDescriptionValue', value);
  };

  const urlOnChange = async (url) => {
    const expression = /[-a-zA-Z0-9@:%_\+.~#?&//=]{2,256}\.[a-z]{2,4}\b(\/[-a-zA-Z0-9@:%_\+.~#?&//=]*)?/gi;
    const regex = new RegExp(expression);
    // if user clear the url then remove the image preview panel
    if (url.target.value === '') {
      setImageUrl('');
    }
    if (url.target.value.match(regex)) {
      setImageUrl(url.target.value);
      getImageData(url.target.value);
    }
  };

  const onToggleChange = (fieldName, event) => {
    if (fieldName === 'active') {
      setActive(event.target.checked);
    } else if (fieldName === 'isPublic') {
      if (event.target.checked) {
        formValues.setValue('visibility', Visibility.UnderReview);
        setVisibilty(Visibility.UnderReview);
      } else {
        formValues.setValue('visibility', Visibility.Private);
        setVisibilty(Visibility.Private);
      }
      setIsPublic(event.target.checked);
    }
    formValues.setValue(fieldName, event.target.checked);
  };
  const tagsChange = (values) => {
    // console.log('values', values);
    const tagsNew = values.map((tag) => {
      return {
        type: 'ApplicationType',
        key: tag.key,
        displayName: tag.displayName,
      };
    });
    formValues.setValue('tags', tagsNew);
  };

  const getModelCategories = () => {
    return MODEL_CATEGORIES.map((item, index) => (
      <MenuItem key={item.id} value={item.name}>
        {item.name}
      </MenuItem>
    ));
  };

  const handleCategoryChange = (selectedCategory: string) => {
    setModelCategory(selectedCategory);
    formValues.setValue('modelCategory', selectedCategory);
  };

  const aliasChangeHandler = async (e) => {
    const { value } = e.target;
    value === '' && setModelModelUrl();
    setValue('modelAlias', value);
  };

  // Restrict user to type value between 0 to 1 in preformance stats
  const handeluserInp = (fieldName: string, value: any) => {
    if (value < 0 || value > 1) {
      setValue(fieldName, 1);
    }
  };

  const handleModelTypeChange = (value) => {
    // console.log('value', value);
    setSelectedModelType(value);
    setValue('modelType', value.id);
  };

  const AliasIncrementerToMakeItUnique = (str: any, aliasDataOfThisString: any) => {
    if (clientUtils.isEmpty(getValues('modelId'))) {
      if (getValues('modelId') !== aliasDataOfThisString.attachedItemId) {
        let pattern = /-\d+/;
        // Check if the string ends with '-1'
        if (pattern.test(str)) {
          // Split the string by '-' to separate the parts
          let parts = str.split('-');
          // Increment the last part by 1
          let incrementedNumber = parseInt(parts[parts.length - 1]) + 1;
          // Concatenate the parts and the incremented number
          return parts.slice(0, -1).join('-') + '-' + incrementedNumber;
        } else {
          return str + '-1';
        }
      } else {
        return str;
      }
    } else {
      return str;
    }
  };

  const onBlurModelname = async (e) => {
    await autoGeneratemodelAliasWithModelname(e.target.value);
  };

  const autoGeneratemodelAliasWithModelname = async (value) => {
    if (!clientUtils.isEmpty(value)) {
      // Replace all special characters except _ and - with -
      let aliansName = value.toLowerCase().replace(/\s+/g, ' ').replace(/[^a-zA-Z0-9_-]/g, '-');
      const { success, data }: any = await modelUtils.modelAliasFetcher(aliansName);
      if (success) {
        aliansName = AliasIncrementerToMakeItUnique(data.id, data);
      }
      setValue('modelAlias', aliansName);
      setModelAliasInputLabelProps(true);
    }
  };

  const setModelModelUrl = () => {
    try {
      if (!clientUtils.isEmpty(getValues('modelAlias'))) {
        const aliasURL = `${window.location.origin}/${getValues('modelAlias')}`;
        setModelUrl(aliasURL);
      } else {
        const originalURL = `${window.location.origin}/models/${orginalModel.modelId}/view`;
        setModelUrl(originalURL);
      }
    } catch (error) {
      console.error('setModelModelUrl', error);
    }
  };

  //  ▶️ Hooks .....
  useEffect(() => {
    const modelType = getValues('modelType');
    if (modelType) {
      const found: any = MODEL_LIST.find((m) => m.id === modelType);
      setSelectedModelType(found);
    }
    if (clientUtils.isEmpty(getValues('modelAlias'))) {
      autoGeneratemodelAliasWithModelname(getValues('modelName'));
    }
  }, []);

  useEffect(() => {
    if (getValues('externalRedirectUrl')) {
      getImageData(getValues('externalRedirectUrl'));
    }
  }, [imageData]);

  useEffect(() => {
    setModelModelUrl();
  }, [getValues('modelAlias')]);

  return (
    <>
      <Card className="card-model cardContainer">
        <Grid container spacing={2} direction={'row'}>
          <Grid item xs={12} sm={12} md={8} lg={8} xl={9}>
            <Grid item container spacing={2}>
              <Grid item xs={6}>
                <TextField
                  id="ModelName"
                  label="Model Name"
                  variant="outlined"
                  placeholder="Model Name"
                  size="small"
                  fullWidth
                  {...register('modelName')}
                  defaultValue={getValues('modelName') ?? ''}
                  onBlur={onBlurModelname}
                />
              </Grid>
              <Grid item xs={6}>
                <AutoCompleteSelect
                  id="model-type-select"
                  items={MODEL_LIST}
                  itemText="name"
                  itemKey="id"
                  labelText="Model Type"
                  placeHolderText="Select Model Type of Model"
                  multiSelect={false}
                  labelPaddingTop="-5px"
                  defaultValue={selectedModelType}
                  onChange={(value) => handleModelTypeChange(value)}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  id="ModelDescription"
                  label="Model Description"
                  variant="outlined"
                  placeholder="Model Description"
                  size="small"
                  fullWidth
                  {...register('modelDescription')}
                  defaultValue={getValues('modelDescription') ?? ''}
                  multiline
                  maxRows={8}
                  minRows={3}
                />
              </Grid>
              <Grid item xs={12} xl={4} lg={4}>
                <TextField
                  id="External Redirect Url"
                  label="External Redirect Url"
                  variant="outlined"
                  placeholder="External Redirect Url"
                  size="small"
                  fullWidth
                  {...register('externalRedirectUrl')}
                  onKeyUp={urlOnChange}
                  defaultValue={getValues('externalRedirectUrl') ?? ''}
                />
              </Grid>
              <Grid item xs={12} xl={4} lg={4}>
                <TextField
                  id="model_category"
                  label="Category"
                  variant="outlined"
                  placeholder="Model Category"
                  fullWidth
                  size="small"
                  value={modelCategory}
                  {...register('modelCategory')}
                  defaultValue={getValues('modelCategory') ?? ''}
                  onChange={(e) => handleCategoryChange(e.target.value)}
                  select // tell TextField to render select
                >
                  {getModelCategories()}
                </TextField>
              </Grid>
              {/* Model Alias */}
              <Grid item xs={12} xl={4} lg={4}>
                <TextField
                  id="Model_Alias"
                  label="Model Alias"
                  variant="outlined"
                  placeholder="Model Alias"
                  size="small"
                  fullWidth
                  {...register('modelAlias')}
                  onChange={aliasChangeHandler}
                  onBlur={(e) => {
                    e.target.value === '' && setModelModelUrl();
                  }}
                  defaultValue={getValues('modelAlias')}
                  InputLabelProps={modelAliasInputLabelProps ? { shrink: true } : {}}
                />
              </Grid>

              {/* Applications */}
              <Grid item xs={12} xl={6} lg={6}>
                <AutoCompleteSelect
                  id="tags-select"
                  items={MODEL_TAGS}
                  itemText="displayName"
                  itemKey="key"
                  labelText="Applications"
                  placeHolderText="Select Applications of Model"
                  multiSelect={true}
                  labelPaddingTop="-5px"
                  defaultValue={getValues('tags')}
                  onChange={tagsChange}
                  limitTags={5}
                />
              </Grid>
              {/* Model URL Copy */}
              <Grid
                item
                xs={12}
                xl={6}
                lg={6}
                // style={{ display: 'flex', justifyItems: 'center', alignItems: 'center', position: 'relative' }}
              >
                <TextField
                  type="text"
                  name={`modelURL`}
                  label="Model URL"
                  placeholder="Model URL"
                  fullWidth
                  disabled={true}
                  size="small"
                  value={ModelUrl}
                  InputLabelProps={ModelUrl ? { shrink: true } : {}}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <div
                          style={{ cursor: 'pointer' }}
                          onClick={() => {
                            clientUtils.copyToClipboard(ModelUrl);
                            alert('URL Copied !', 'success');
                          }}
                        >
                          <ContentCopyIcon />
                        </div>
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <FormControlLabel
                  sx={{ ml: 0 }}
                  control={<Switch size="small" checked={active} />}
                  onChange={(e) => onToggleChange('active', e)}
                  label="Active"
                  labelPlacement="start"
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <FormControlLabel
                  sx={{ ml: 0 }}
                  control={
                    <div style={{ display: 'flex' }}>
                      <Switch
                        size="small"
                        checked={isPublic}
                        color={visibility === Visibility.UnderReview ? 'warning' : 'info'}
                      />
                      {orginalModel.visibility === Visibility.Private && visibility === Visibility.UnderReview && (
                        <div style={{ paddingLeft: '3px', paddingTop: '1px' }}>(To Be Reviewed)</div>
                      )}
                      {orginalModel.visibility === Visibility.UnderReview && visibility === Visibility.UnderReview && (
                        <div style={{ paddingLeft: '3px', paddingTop: '1px' }}>(Under Review)</div>
                      )}
                    </div>
                  }
                  onChange={(e) => onToggleChange('isPublic', e)}
                  label="Public"
                  labelPlacement="start"
                />
              </Grid>
            </Grid>
          </Grid>
          <>
            <Grid item xs={12} sm={12} md={4} lg={4} xl={3}>
              {isLoading ? (
                <div className="screenshotLoader">
                  <CircularProgress />
                  <span className="screenshotSpan">Loading Site Preview...</span>
                </div>
              ) : (
                <div className="screenshotLoader">
                  {imageUrl && imageUrl !== '' && (
                    <img className="screenshotImg" src={`data:image/png;base64,${imageData}`} loading="lazy" />
                  )}
                  {imageUrl === '' && <span className="screenshotSpan">Website Preview Not Available!</span>}
                </div>
              )}
            </Grid>
          </>
          <Grid item xs={12}>
            {/* <Label for="longDescription">Long Description</Label> */}
            <Typography>Long Description</Typography>
            <TextEditor htmlValue={modelLongDescription} onEditorChange={onEditorChange} />
          </Grid>
          <Grid item xs={12} sx={{ mt: 2 }}>
            <h5 style={{ fontSize: '16px', fontWeight: 'bold', marginBottom: '-10px' }}>Pricing</h5>
            <hr />
          </Grid>
          <Grid item xs={6}>
            <TextField
              id="usageCharge"
              label="Usage Charge"
              variant="outlined"
              placeholder="Usage Charge"
              size="small"
              fullWidth
              type="number"
              inputProps={{
                step: 1.0,
                min: 0,
              }}
              {...register('pricingInfo.perInferenceUsageCharge')}
              defaultValue={getValues('pricingInfo.perInferenceUsageCharge') ?? ''}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              id="servicePricingInfo"
              label="Pricing Info"
              variant="outlined"
              placeholder="Pricing Info"
              size="small"
              fullWidth
              {...register('pricingInfo.servicePricingInfo')}
              defaultValue={getValues('pricingInfo.servicePricingInfo') ?? ''}
            />
          </Grid>
          <Grid item xs={12}>
            <Controller
              name="pricingInfo.modelOwnerPaysComputeCost"
              control={control}
              render={({ field: { onChange, value } }) => (
                <FormControlLabel
                  sx={{ ml: 0 }}
                  control={<Switch size="small" checked={value} onChange={onChange} />}
                  label="Model owner pays hosting costs"
                  labelPlacement="end"
                />
              )}
            />
          </Grid>
          <Grid item xs={12}>
            <Controller
              name="pricingInfo.noChargeOnInferenceWithError"
              control={control}
              render={({ field: { onChange, value } }) => (
                <FormControlLabel
                  sx={{ ml: 0 }}
                  control={<Switch size="small" checked={value} onChange={onChange} />}
                  label="Do not charge user if error occurs (recommended)"
                  labelPlacement="end"
                />
              )}
            />
          </Grid>
          <Grid item xs={12}>
            <Controller
              name="pricingInfo.skipUsageChargeInSameCtx"
              control={control}
              render={({ field: { onChange, value } }) => (
                <FormControlLabel
                  sx={{ ml: 0 }}
                  control={<Switch size="small" checked={value} onChange={onChange} />}
                  label="No usage charge within same context (only if model 'Needs Context')"
                  labelPlacement="end"
                />
              )}
            />
          </Grid>
          <Grid item xs={12} sx={{ mt: 2 }}>
            <h5 style={{ fontSize: '16px', fontWeight: 'bold', marginBottom: '-10px' }}>Performance Stats</h5>
            <hr />
          </Grid>
          <Grid item xs={12}>
            <Matrics />
          </Grid>
          <Grid item xs={12} sx={{ mt: 2 }}>
            <h5 style={{ fontSize: '1rem', fontWeight: 'bold', marginBottom: '-10px' }}>Supporting Links</h5>
            <hr />
          </Grid>
          <Grid item xs={12}>
            <SupportingLinks />
          </Grid>
        </Grid>
      </Card>
    </>
  );
};

export default ModelInfo;
